import { createFileRoute } from '@tanstack/react-router'
import { ImprintPage } from '../features/legal/ImprintPage'

export const Route = createFileRoute('/_auth/legal/imprint')({
  component: ImprintPage,
})
